/** Normalize axios/Fastify status from common error shapes. */
export function getErrorStatus(err: any): number | null {
  const raw =
    err?.response?.status ??
    err?.response?.data?.statusCode ??
    err?.status ??
    err?.statusCode;
  const status = Number(raw);
  return Number.isFinite(status) ? status : null;
}

/** True when draw details should show the access-denied modal (not the generic API error popup). */
export function isDrawAccessDeniedStatus(
  status?: number | null
): boolean {
  const code = Number(status);
  return code === 403 || code === 404;
}

export function isDrawAccessDeniedError(err: any): boolean {
  return isDrawAccessDeniedStatus(getErrorStatus(err));
}

/** Draws list path for the current user type (originator vs AM). */
export function resolveDrawsListPath(isOriginator: boolean): string {
  return isOriginator ? "/loans/list?tab=8" : "/asset/home";
}
